import { useState, useEffect, useRef } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

export default function ActivityPhotos() {
  const [tab, setTab] = useState('photos')
  const [uploading, setUploading] = useState(false)
  const [photos, setPhotos] = useState([])
  const [claimCodes, setClaimCodes] = useState([])
  const [children, setChildren] = useState([])
  const [activities, setActivities] = useState([])
  const [selectedActivity, setSelectedActivity] = useState('')
  const [linkingChild, setLinkingChild] = useState(null)
  const [loading, setLoading] = useState(false)
  const [uploadProgress, setUploadProgress] = useState(0)
  const [uploadToken, setUploadToken] = useState('')
  const [cdnDomain] = useState('https://cdn.boxiaotu.cn')
  const fileInputRef = useRef(null)
  const API = VITE_API_BASE

  const loadUploadConfig = async () => {
    try {
      const res = await fetch(API + '/upload/token')
      const data = await res.json()
      if (data.success) {
        setUploadToken(data.data.token)
        return data.data.token
      }
    } catch (e) { console.error('Config error:', e) }
    return null
  }

  const uploadFile = async (file, token) => {
    const ext = file.name.split('.').pop() || 'jpg'
    const key = 'activity-photos/' + Date.now() + '_' + Math.random().toString(36).slice(2) + '.' + ext
    const formData = new FormData()
    formData.append('token', token)
    formData.append('file', file)
    formData.append('key', key)
    const res = await fetch('https://upload.qiniup.com', { method: 'POST', body: formData })
    const data = await res.json()
    if (data.error) {
      if (data.error === 'expired token' || data.error === 'invalid token') {
        const newToken = await loadUploadConfig()
        if (newToken) return uploadFile(file, newToken)
      }
      throw new Error(data.error || 'Upload failed')
    }
    return cdnDomain + '/' + key
  }

  useEffect(() => { 
    loadClaimCodes()
    loadChildren()
    loadActivities()
    loadUploadConfig()
  }, [])

  useEffect(() => {
    if (selectedActivity) loadActivityPhotos(selectedActivity)
  }, [selectedActivity])

  const loadClaimCodes = () => {
    fetch(API + '/claim-codes').then(r => r.json())
      .then(d => { if (d.success && d.data && d.data.length > 0) setClaimCodes(d.data) })
      .catch(e => { console.error(e) })
  }

  const loadChildren = () => {
    fetch(API + '/children').then(r => r.json())
      .then(d => { if (d.success) setChildren(d.data || []) })
      .catch(e => { console.error(e) })
  }

  const loadActivities = () => {
    fetch(API + '/study-activities').then(r => r.json())
      .then(d => { 
        if (d.success) {
          setActivities(d.data || [])
          if (d.data && d.data.length > 0) setSelectedActivity(d.data[0].id)
        }
      })
      .catch(e => { console.error(e) })
  }

  const loadActivityPhotos = (activityId) => {
    setLoading(true)
    fetch(API + '/photo-recognition/activity-photos/' + activityId).then(r => r.json())
      .then(d => {
        if (d.success) setPhotos(d.data?.photos || [])
        setLoading(false)
      })
      .catch(() => setLoading(false))
  }

  const handleUploadClick = () => fileInputRef.current?.click()

  const handleFileChange = async (e) => {
    const files = e.target.files
    if (!files || files.length === 0) return
    setUploading(true)
    setUploadProgress(0)
    let token = uploadToken
    if (!token) token = await loadUploadConfig()
    for (let i = 0; i < files.length; i++) {
      try {
        const photoUrl = await uploadFile(files[i], token)
        await fetch(API + '/photo-recognition/activity-photos/' + selectedActivity, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ url: photoUrl, file_name: files[i].name })
        })
        setUploadProgress(Math.round(((i + 1) / files.length) * 100))
      } catch (err) { alert('Upload failed: ' + err.message) }
    }
    setUploading(false)
    setUploadProgress(0)
    if (selectedActivity) loadActivityPhotos(selectedActivity)
  }

  const handleLinkPhoto = async (photoId, childId) => {
    try {
      const res = await fetch(API + '/photo-recognition/link-photo', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ photo_id: photoId, child_id: childId })
      })
      const data = await res.json()
      if (data.success) {
        alert('关联成功！！')
        setLinkingChild(null)
        loadActivityPhotos(selectedActivity)
      } else { alert(data.error || 'Link failed') }
    } catch (e) { alert('Link failed: ' + e.message) }
  }

  return (
    <div style={{ padding: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h2 style={{ margin: 0, fontSize: 20 }}>活动照片</h2>
        <div style={{ display: 'flex', gap: 8 }}>
          <button onClick={() => setTab('photos')} style={{ padding: '6px 16px', background: tab === 'photos' ? '#1890ff' : '#fff', color: tab === 'photos' ? '#fff' : '#666', border: '1px solid #d9d9d9', borderRadius: 4, cursor: 'pointer' }}>照片</button>
          <button onClick={() => setTab('claim')} style={{ padding: '6px 16px', background: tab === 'claim' ? '#1890ff' : '#fff', color: tab === 'claim' ? '#fff' : '#666', border: '1px solid #d9d9d9', borderRadius: 4, cursor: 'pointer' }}>认领</button>
        </div>
      </div>
      <input type="file" ref={fileInputRef} style={{ display: 'none' }} accept="image/*" multiple onChange={handleFileChange} />
      {tab === 'photos' && (
        <div style={{ background: '#fff', borderRadius: 8, padding: 24 }}>
          <div style={{ marginBottom: 20 }}>
            <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>选择活动</label>
            <select value={selectedActivity} onChange={e => setSelectedActivity(e.target.value)} style={{ width: '100%', padding: '8px 12px', border: '1px solid #d9d9d9', borderRadius: 4 }}>
              {activities.map(a => <option key={a.id} value={a.id}>{a.name}</option>)}
            </select>
          </div>
          <div style={{ border: '2px dashed #d9d9d9', borderRadius: 8, padding: 60, textAlign: 'center', cursor: 'pointer', background: uploading ? '#f5f5f5' : '#fff' }} onClick={!uploading ? handleUploadClick : undefined}>
            {uploading ? (
              <div>
                <div style={{ fontSize: 48, marginBottom: 12 }}>上传中...</div>
                <div>{uploadProgress}%</div>
                <div style={{ width: '60%', height: 4, background: '#e8e8e8', borderRadius: 2, margin: '16px auto' }}>
                  <div style={{ width: uploadProgress + '%', height: '100%', background: '#1890ff', borderRadius: 2 }} />
                </div>
              </div>
            ) : (
              <div>
                <div style={{ fontSize: 48, marginBottom: 12 }}>📸</div>
                <div style={{ fontSize: 15, color: '#666' }}>点击上传照片</div>
                <div style={{ fontSize: 12, color: '#999', marginTop: 8 }}>支持 JPG、PNG，单张不超过 10MB</div>
              </div>
            )}
          </div>
          {loading ? <div style={{ textAlign: 'center', padding: 40 }}>加载中...</div> : (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: 16, marginTop: 24 }}>
              {photos.map(photo => (
                <div key={photo.id} style={{ position: 'relative', borderRadius: 8, overflow: 'hidden', border: '1px solid #e8e8e8' }}>
                  <img src={photo.url} alt="" style={{ width: '100%', height: 150, objectFit: 'cover' }} />
                  {photo.child_id ? (
                    <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, background: 'rgba(0,0,0,0.6)', color: '#fff', padding: '4px 8px', fontSize: 11 }}>
                      {children.find(c => c.id === photo.child_id)?.name || photo.child_id}
                    </div>
                  ) : (
                    <button onClick={() => setLinkingChild(photo.id)} style={{ position: 'absolute', bottom: 4, right: 4, padding: '4px 8px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 4, fontSize: 11, cursor: 'pointer' }}>认领</button>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      )}
      {tab === 'claim' && (
        <div style={{ background: '#fff', borderRadius: 8, padding: 24 }}>
          <h3 style={{ marginTop: 0 }}>认领码</h3>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead><tr style={{ borderBottom: '1px solid #e8e8e8' }}><th style={{ padding: 12, textAlign: 'left' }}>认领码</th><th style={{ padding: 12, textAlign: 'left' }}>类型</th><th style={{ padding: 12, textAlign: 'left' }}>状态</th></tr></thead>
            <tbody>{claimCodes.map(code => (
              <tr key={code.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                <td style={{ padding: 12, fontFamily: 'monospace' }}>{code.code}</td>
                <td style={{ padding: 12 }}>{code.type}</td>
                <td style={{ padding: 12 }}><span style={{ padding: '2px 8px', background: code.used ? '#f5f5f5' : '#e6f7ff', color: code.used ? '#999' : '#1890ff', borderRadius: 4, fontSize: 12 }}>{code.used ? '已使用' : '可用'}</span></td>
              </tr>
            ))}</tbody>
          </table>
          {claimCodes.length === 0 && <div style={{ textAlign: 'center', padding: 40, color: '#999' }}>暂无认领码</div>}
        </div>
      )}
      {linkingChild && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: 8, padding: 24, width: 400 }}>
            <h3 style={{ marginTop: 0 }}>关联孩子</h3>
            <div style={{ maxHeight: 300, overflow: 'auto' }}>
              {children.map(child => (
                <div key={child.id} onClick={() => handleLinkPhoto(linkingChild, child.id)} style={{ padding: 12, cursor: 'pointer', borderRadius: 4, marginBottom: 4, background: '#f5f5f5' }}>
                  {child.name || '未命名'} - {child.parent_phone || '无电话'}
                </div>
              ))}
            </div>
            <button onClick={() => setLinkingChild(null)} style={{ marginTop: 16, padding: '8px 24px', background: '#fff', border: '1px solid #d9d9d9', borderRadius: 4, cursor: 'pointer' }}>取消</button>
          </div>
        </div>
      )}
    </div>
  )
}
